import React from 'react'
import { Box, Grid2 } from '@mui/material'
import { useMe } from '../app/MeContext'
import CurrentListenerCountCard from '../components/dashboard/CurrentListenerCountCard'
import ListenerCountHistoryCard from '../components/dashboard/ListenerCountHistoryCard'
import UnreadMessagesCard from '../components/dashboard/UnreadMessagesCard'
import NewMessagesLast24HoursCard from '../components/dashboard/NewMessagesLast24HoursCard'
import NewPrepItemsLast24HoursCard from '../components/dashboard/NewPrepItemsLast24HoursCard'
import MyPrepItemsCard from '../components/dashboard/MyPrepItemsCard'
import { useDashboardStats } from '../store/dashboardStats'
import { usePageTitle } from '../components/common/PageTitleContext'

const Dashboard: React.FC = () => {
  const me = useMe()
  usePageTitle('Dashboard', { showBreadcrumbs: false })
  const activeStationId = React.useMemo(() => {
    const id = me.stations?.[0]?.id
    return typeof id === 'number' && Number.isFinite(id) && id > 0 ? id : null
  }, [me.stations])

  useDashboardStats(activeStationId)

  return (
    <Box sx={{ p: { xs: 1.5, md: 2 } }}>
      <Grid2 container spacing={1} columns={{ xs: 12, md: 12 }}>
        <Grid2 xs={12}>
          <Grid2 container spacing={1} columns={{ xs: 12, md: 12 }}>
            <Grid2 xs={12} md={3}>
              <UnreadMessagesCard stationId={activeStationId} />
            </Grid2>
            <Grid2 xs={12} md={3}>
              <NewMessagesLast24HoursCard stationId={activeStationId} />
            </Grid2>
            <Grid2 xs={12} md={3}>
              <NewPrepItemsLast24HoursCard stationId={activeStationId} />
            </Grid2>
            <Grid2 xs={12} md={3}>
              <MyPrepItemsCard stationId={activeStationId} />
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 xs={12}>
          <Grid2 container spacing={1} columns={{ xs: 12, md: 12 }}>
            <Grid2 xs={12} md={3}>
              <CurrentListenerCountCard stationId={activeStationId} />
            </Grid2>
            <Grid2 xs={12} md={9}>
              <ListenerCountHistoryCard stationId={activeStationId} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Box>
  )
}

export default Dashboard
